"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUERY_LIST_SECTION = void 0;
const QUERY_LIST_SECTION = exports.QUERY_LIST_SECTION = 'query-list-section';
